import React, { useState } from "react";
import { AllRoutes } from "config/routeMgt/AllRoutes";
import { AuthProvider } from "react-auth-kit";
import { QueryClient, QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd";
import { TourGuideProvider } from "components/layout/components/tours/TourGuideContext";
import CustomEmpty from "components/CustomEmpty";
import ReportBugDrawer from "./components/layout/components/ReportBug/ReportBugDrawer";
import "./App.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const [isBugDrawerOpen, setIsBugDrawerOpen] = useState<boolean>(false);

  const handleCloseDrawer = () => {
    setIsBugDrawerOpen(false);
  };

  const handleToggleDrawer = () => {
    setIsBugDrawerOpen(!isBugDrawerOpen);
  };

  return (
    <AuthProvider authType="localstorage" authName="arno-app">
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          renderEmpty={() => <CustomEmpty message="No records found" />}
          theme={{
            token: {
              colorPrimary: "#01065a",
            },
          }}
        >
          <TourGuideProvider>
            <AllRoutes />
          </TourGuideProvider>

          <button
            onClick={handleToggleDrawer}
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              padding: "6px 12px 6px 8px",
              borderRadius: "20px",
              backgroundColor: isBugDrawerOpen ? "#dc2626" : "#6366f1",
              color: "white",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(1, 6, 90, 0.2)",
              transition: "all 0.2s ease",
              fontFamily: "inherit",
              fontSize: "11px",
              fontWeight: "500",
              outline: "none",
              WebkitTapHighlightColor: "transparent",
              lineHeight: 1,
            }}
            aria-label={isBugDrawerOpen ? "Close Feedback" : "Provide Feedback"}
          >
            {isBugDrawerOpen ? (
              <>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                <span>Close</span>
              </>
            ) : (
              <>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
                </svg>
                <span>Report Issues</span>
              </>
            )}
          </button>

          <ReportBugDrawer
            isOpen={isBugDrawerOpen}
            onClose={handleCloseDrawer}
          />
        </ConfigProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
};

export default App;
